package com.devi3east.bashbuddy.cart.ui

import com.devi3east.bashbuddy.cart.domain.models.CartFeeBreakdown
import com.devi3east.bashbuddy.cart.domain.models.CartItem

data class CartUiState(
    val items: List<CartItem> = emptyList(),
    val fees: CartFeeBreakdown? = null,
    val isLoading: Boolean = false,
    val errorMessage: String? = null,
    val successMessage: String? = null,
    val inventoryErrorMessage: String? = null
)